import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { LeaderItemSkeleton } from '../LeaderItemSkeleton';
interface IProps {
  groupsCount?: number;
  itemsPerGroup?: number;
  /** If false, renders a simple list without grouping */
  grouped?: boolean;
  /** Total items count when grouped=false */
  itemsCount?: number;
}
const GroupSkeleton = t0 => {
  const $ = _c(6);
  const {
    percentile,
    itemsCount
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex w-full max-w-12 flex-col justify-center gap-1"><div className="h-[14px] w-[30px] rounded bg-white/20 sm-tablet:h-[18px]" /><div className="h-[18px] w-[35px] rounded bg-white/20 sm-tablet:h-[22px]" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== itemsCount) {
    t2 = Array.from({
      length: itemsCount
    });
    $[1] = itemsCount;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== percentile || $[4] !== t2) {
    t3 = <div className="flex min-h-[74px] w-full animate-pulse items-center justify-center gap-2 rounded-[16px] bg-[#31324B59] px-4 py-2 sm-tablet:py-4">{t1}<div className="flex w-full flex-col gap-1 sm-tablet:gap-2">{t2.map((_, index) => <LeaderItemSkeleton key={`${percentile}-${index}`} />)}</div></div>;
    $[3] = percentile;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export const LeaderListSkeleton: FC<IProps> = t0 => {
  const $ = _c(8);
  const {
    groupsCount: t1,
    itemsPerGroup: t2,
    grouped: t3,
    itemsCount: t4
  } = t0;
  const groupsCount = t1 === undefined ? 3 : t1;
  const itemsPerGroup = t2 === undefined ? 2 : t2;
  const grouped = t3 === undefined ? true : t3;
  const itemsCount = t4 === undefined ? 5 : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [10, 20, 30, 40, 50];
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const percentiles = t5;
  if (!grouped) {
    let t6;
    if ($[1] !== itemsCount) {
      t6 = <div className="flex w-full flex-col gap-1 sm-tablet:gap-2">{Array.from({
          length: itemsCount
        }).map(_temp)}</div>;
      $[1] = itemsCount;
      $[2] = t6;
    } else {
      t6 = $[2];
    }
    return t6;
  }
  let t6;
  if ($[3] !== groupsCount) {
    t6 = percentiles.slice(0, groupsCount);
    $[3] = groupsCount;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== itemsPerGroup || $[6] !== t6) {
    t7 = <div className="flex w-full flex-col gap-3 sm-tablet:gap-4">{t6.map(percentile => <GroupSkeleton key={percentile} percentile={percentile} itemsCount={itemsPerGroup} />)}</div>;
    $[5] = itemsPerGroup;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
};
function _temp(_, index) {
  return <LeaderItemSkeleton key={`item-${index}`} />;
}